import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { GridCard, GridList } from 'src/components'
import { useCancelLibraryImpactRemove, useNotification, useRemoveLibraryImpacts } from 'src/hooks'
import { TrashTimeoutIcon } from 'src/assets/icons'

import { IImpactLibraryDtoWithId } from 'src/types'

interface IImpactsLibraryGridProps {
  impacts?: IImpactLibraryDtoWithId[] | void
}

const ImpactsLibraryGrid = ({ impacts }: IImpactsLibraryGridProps) => {
  const [t] = useTranslation()
  const { mutateAsync } = useRemoveLibraryImpacts()
  const { mutateAsync: cancelRemove } = useCancelLibraryImpactRemove()
  const { notify } = useNotification()
  const navigate = useNavigate()

  const handleDelete = (id: string) => async () => {
    const resp = await mutateAsync([id])
    if (!resp) return
    notify({
      message: t('items-delete-notification.v'),
      icon: <TrashTimeoutIcon />,
      onButtonClick: async () => {
        await cancelRemove({ ids: [id] })
      },
      timeout: 14000,
    })
  }

  const handleDuplicate = (id: string) => () => {
    navigate(`add?libraryDuplicate=${id}`)
  }

  const createItems = (id: string) => [
    {
      title: t('delete-button-text'),
      onClick: handleDelete(id),
    },
    {
      title: t('duplicate-button-text'),
      onClick: handleDuplicate(id),
    },
  ]

  return (
    <GridList entityCountKey="impactsCount" routeToAdd="add" showUpgrade>
      {impacts?.map(({ id, name, image, image_medium }) => (
        <GridCard
          image={image_medium || image}
          key={id}
          name={name}
          route={`${id}`}
          items={createItems(id)}
        />
      ))}
    </GridList>
  )
}

export { ImpactsLibraryGrid }
